module.exports = __webpack_public_path__ + "img/finish-logo.f60f0091.png";